export default __webpack_public_path__ + "static/media/hht1_ep01_le01_mini_img_01_t1_t.8ada9e3a.png";